import React from 'react';
import LinkChd from '../../LinkChd';

type Props = {
  title: string,
  links: any,
}

export default function ExploreSection({ title, links }: Props) {
  return (
    <>
      <h6 className="font-semibold text-[16px] py-[5px] font-['Open_Sans'] text-dimGray">{title}</h6>
      <nav>
        <ul>
          {links && links.map((item: any) => (
            <li className="my-2" key={item.id}>
              <LinkChd
                link={item}
                linkStyles="font-semibold text-[28px] whitespace-nowrap font-['Open_Sans'] text-darkCyan hover:text-blueLagoon"
                linkTitle={item.title}
              />
            </li>
          ))}
        </ul>
      </nav>
    </>
  );
}
